import { GCInstant as platform } from 'src/lib/gcinstant';
import { user } from 'src/StateObserver';
import features from 'src/replicant/ruleset/features';
import { isLineIAPAvailable } from 'src/game/iap/component/iap.api';

/**
 * Minimum match2 level required before the TOS nudge gate is shown.
 * Users below this level can collect Daily Bonus without TOS acceptance.
 * This ensures new players aren't blocked early in their experience.
 */
const DAILY_BONUS_TOS_LEVEL_THRESHOLD = 15;

/**
 * Check if user should see TOS nudge before collecting daily bonus.
 *
 * When the daily bonus collect flow is triggered, this function determines
 * whether to show a LINE Purchase TOS consent prompt first. This drives
 * IAP eligibility by converting daily bonus collectors into TOS-accepted
 * users who can then make in-app purchases.
 *
 * Gated by the `iapTosDailyBonus` feature flag in features.ts
 * (resolved from A/B test 0433 to always-enabled).
 *
 * Conditions:
 * 1. Feature flag `iapTosDailyBonus` is enabled
 * 2. User is in LINE Mini App with IAP available
 * 3. User has NOT accepted LINE Purchase TOS
 * 4. User level >= threshold (15)
 */
export function shouldShowDailyBonusTosNudge(): boolean {
  const state = user();

  // Feature flag kill-switch (see features.ts iapTosDailyBonus)
  if (!features(state).iapTosDailyBonus) return false;

  // Only relevant in LINE Mini App with IAP ready
  if (!isLineIAPAvailable()) return false;

  // Skip if TOS already accepted
  const hasAcceptedTos =
    platform.storage.linePurchaseTOSLastAcceptedAt !== undefined;
  if (hasAcceptedTos) return false;

  // Only show for users past the early game
  if (state.match2.level < DAILY_BONUS_TOS_LEVEL_THRESHOLD) return false;

  return true;
}
